"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasSchema = exports.getSchema = exports.validateParams = exports.validateArrayAsClass = exports.validateAsClass = exports.validate = exports.string = exports.object = exports.number = exports.link = exports.joi = exports.func = exports.date = exports.boolean = exports.array = exports.any = exports.DEFAULT_INSTANCE = exports.Joiful = exports.isValidationFail = exports.isValidationPass = exports.MultipleValidationError = exports.Validator = void 0;
const joiful_1 = require("./joiful");
const validation_1 = require("./validation");
var validation_2 = require("./validation");
Object.defineProperty(exports, "Validator", { enumerable: true, get: function () { return validation_2.Validator; } });
Object.defineProperty(exports, "MultipleValidationError", { enumerable: true, get: function () { return validation_2.MultipleValidationError; } });
Object.defineProperty(exports, "isValidationPass", { enumerable: true, get: function () { return validation_2.isValidationPass; } });
Object.defineProperty(exports, "isValidationFail", { enumerable: true, get: function () { return validation_2.isValidationFail; } });
var joiful_2 = require("./joiful");
Object.defineProperty(exports, "Joiful", { enumerable: true, get: function () { return joiful_2.Joiful; } });
exports.DEFAULT_INSTANCE = new joiful_1.Joiful();
const DEFAULT_VALIDATOR = new validation_1.Validator();
const { validate, validateAsClass, validateArrayAsClass } = DEFAULT_VALIDATOR;
exports.validate = validate;
exports.validateAsClass = validateAsClass;
exports.validateArrayAsClass = validateArrayAsClass;
const { any, array, boolean, date, func, joi, link, number, object, string, validateParams, getSchema, hasSchema, } = exports.DEFAULT_INSTANCE;
exports.any = any;
exports.array = array;
exports.boolean = boolean;
exports.date = date;
exports.func = func;
exports.joi = joi;
exports.link = link;
exports.number = number;
exports.object = object;
exports.string = string;
exports.validateParams = validateParams;
exports.getSchema = getSchema;
exports.hasSchema = hasSchema;
//# sourceMappingURL=index.js.map